module.exports = "/_next/static/videos/lacrosse-2-ec8a58ad69a4ce1c07b271080b752e94.webm";